import React from 'react'
import { SubscriptionContext } from '../context'
import { Card, CardHeading, CardContent, CardFooter } from '@components/layout/Card'
import { Details, DetailsActions } from './Details'
import { Show, ShowActions } from './Show'
import { CardDetails, CardDetailsActions } from './CardDetails'

export const Views = () => {
  const { state: { view, permissions: { editBilling, editSubscription }} } = React.useContext(SubscriptionContext)
  const formRef = React.useRef<HTMLFormElement>(null)

  const canEdit = editBilling || editSubscription

  return (
    <Card>
      <CardHeading>
        <h5>Subscription Details</h5>
      </CardHeading>
      <CardContent>
        {
          {
            show: () => <Show />,
            details: () => <Details formRef={formRef} />,
            card: () => <CardDetails />,
          }[view || 'show']()
        }
      </CardContent>
      {canEdit && <CardFooter>
        {
          {
            show: () => <ShowActions />,
            details: () => <DetailsActions formRef={formRef}/>,
            card: () => <CardDetailsActions />
          }[view || 'show']()
        }
      </CardFooter>}
    </Card>
  )
}
